import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { trimLowerCase, isUndefinedNull } from '../helpers/shared'
import { setCategoriesTierFields, setTierFields, setFieldsCategories } from '../helpers/tier'
import { TIER_SET_TIERS } from '../redux/types/tier'
import { useDispatch } from 'react-redux'

/**
 * Custom hook to be used in the Files (rejected/expired) section
 * Its main purpose is to fetch 'tiers' (TIER_SET_TIERS), in case no 'tiers' is found
 * @returns 
 */
const useAltFiles = () => {

  const { tiers, lastTier } = useSelector(state => state.tier);
  const { requestLanguage, loading } = useSelector(state => state.base);
  const {
    field_category: categories,
    tier: allTiers,
    tier_field: tiersFields,
    field: fields
  } = useSelector(state => state.staticData[`data_${trimLowerCase(
    requestLanguage)}`]) || {};
  const dispatch = useDispatch()

  useEffect(() => {
      if (isUndefinedNull(tiers)) {
        const response = {};
        Array.from(allTiers).forEach(item => {
          if (item.regular && item.active) {
            const uniqueName = trimLowerCase(item.unique_name);
            const tierCategoriesFields = setCategoriesTierFields(
              categories, item, tiersFields);
            const tierFields = setTierFields(fields, item, tiersFields);
            const fieldsCategories = setFieldsCategories(
              tierCategoriesFields, tierFields, item);
            response[uniqueName] = {};
            response[uniqueName]['fields'] = tierFields;
            response[uniqueName]['data'] = item;
            response[uniqueName]['categories'] = {};
            response[uniqueName]['categories']['data'] = tierCategoriesFields;
            response[uniqueName]['categories']['fields'] = fieldsCategories;
          }
        });
        dispatch({ type: TIER_SET_TIERS, payload: response });
      }
  }, [tiers, allTiers, categories, tiersFields, fields]);

  /* Reloading page if loader doesnt dissapear after 6 seconds */
  useEffect(() => {
    const timer = setTimeout(() => {
      if (loading) {
        window.location.reload();
      }
    }, 6000);

    return () => clearTimeout(timer);
  }, [loading]);

  return {

  }
}

export default useAltFiles